import { render, staticRenderFns } from "./BidHeader.vue?vue&type=template&id=098a2ce0&"
import script from "./BidHeader.vue?vue&type=script&lang=js&"
export * from "./BidHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports